import { render } from "./suplierTypeAdd.vue?vue&type=template&id=14fe6500&scoped=true"
import script from "./suplierTypeAdd.vue?vue&type=script&lang=js"
export * from "./suplierTypeAdd.vue?vue&type=script&lang=js"

import "./suplierTypeAdd.vue?vue&type=style&index=0&id=14fe6500&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14fe6500"]])

export default __exports__